import React from 'react';
import PropTypes from 'prop-types';

import { StatePill } from '@common/components';

export const ASSIGNMENT_STATE_INFO = {
  onboarding: {
    label: 'Onboarding',
    action: 'onboard',
    color: 'harvest-gold',
  },
  cleared: {
    label: 'Cleared',
    action: 'clear',
    color: 'grass-lighter',
  },
  working: {
    label: 'Working',
    action: 'work',
    color: 'grass',
  },
  completed: {
    label: 'Completed',
    action: 'complete',
    color: 'grass-darkest',
  },
  cancelled: {
    label: 'Cancelled',
    action: 'cancel',
    color: 'coral-hyperlight',
  },
};

function OnboardingProgress({ completedTasksCount, totalTasksCount }) {
  if (
    typeof completedTasksCount !== 'number' ||
    typeof totalTasksCount !== 'number'
  )
    return null;

  return (
    <React.Fragment>
      {' '}
      {completedTasksCount}/{totalTasksCount}
    </React.Fragment>
  );
}

export function AssignmentStatePill(props) {
  const {
    state,
    completedTasksCount,
    totalTasksCount,
    fontSize,
    neverStarted,
    ...other
  } = props;

  let { label, color } = ASSIGNMENT_STATE_INFO[state] || {
    label: state,
    action: null,
    color: '',
  };

  return (
    <>
      <StatePill {...other} color={color} fontSize={fontSize}>
        {label}
        {state === 'onboarding' && (
          <OnboardingProgress
            completedTasksCount={completedTasksCount}
            totalTasksCount={totalTasksCount}
          />
        )}
      </StatePill>
      {neverStarted && (
        <StatePill color="coral-hyperlight" fontSize={fontSize}>
          Never Started
        </StatePill>
      )}
    </>
  );
}

AssignmentStatePill.propTypes = {
  state: PropTypes.string.isRequired,
  neverStarted: PropTypes.bool,
  completedTasksCount: PropTypes.number,
  totalTasksCount: PropTypes.number,
  dropdown: PropTypes.bool,
  fontSize: PropTypes.string,
};

AssignmentStatePill.defaultProps = {
  dropdown: false,
};

OnboardingProgress.propTypes = {
  completedTasksCount: PropTypes.number,
  totalTasksCount: PropTypes.number,
};
